import script from "./PublicDataTour.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicDataTour.vue?vue&type=script&setup=true&lang=js"

import "./PublicDataTour.vue?vue&type=style&index=0&id=78b167fe&lang=css"
import "./PublicDataTour.vue?vue&type=style&index=1&id=78b167fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b167fe"]])

export default __exports__